import { ReactNode, useMemo } from 'react';

import LayoutV2FAQs from './components/FAQs';
import LayoutV2Footer from './components/Footer';
import LayoutV2Header from './components/Header';
import LayoutV2HelpCenter from './components/HelpCenter';

export interface LayoutV2Props {
  sidePanel?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

const LayoutV2: React.FunctionComponent<LayoutV2Props> = function ({
  sidePanel,
  header,
  footer,
  children,
}) {
  const leftFlexClassName = useMemo(
    () => [sidePanel ? 'bg-neutral-50' : '', 'flex-[1_1_0]'].join(' '),
    [sidePanel],
  );

  return (
    <div className="flex flex-col w-screen min-h-screen bg-neutral-100">
      <LayoutV2Header />
      <div className="flex flex-1 flex-row max-w-full">
        <div className={leftFlexClassName} />
        <div className="flex flex-col flex-[0_1_1280px] w-full max-w-7xl">
          {header}
          <div className="flex flex-1 flex-row">
            {sidePanel && (
              <div className="hidden md:flex border-r border-neutral-200 bg-neutral-50">
                {sidePanel}
              </div>
            )}
            <div className="flex flex-col flex-1 p-4 md:px-6 md:py-6 lg:py-12 gap-y-8 max-w-full">
              <div className="flex flex-1 w-full">{children}</div>
              <LayoutV2FAQs />
              <LayoutV2HelpCenter />
              <LayoutV2Footer />
            </div>
          </div>
          {footer}
        </div>
        <div className="flex-[1_1_0]" />
      </div>
    </div>
  );
};

export default LayoutV2;
